import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { ILink } from '../../../models/link';

@Component({
  selector: 'input-file',
  templateUrl: './input-file.component.html',
  styles: [
    `
      .dragdrop {
        padding: 25px 15px 25px 15px;
        border: dashed 1px var(--sidebar-bg);
        border-radius: 15px;
      }

      .form-control {
        height: auto;
        padding: 15px;
        border-radius: 15px;
        border: none;
        cursor: pointer;
      }
      .upload-info {
        display: grid;
        color: #b5a2df;
        font-size: xx-small;
        white-space: pre-line;
      }
      .bottom-info {
        font-size: xx-small; 
        font-weight: 700; 
        color: #4f21b2;
        text-align: center;
      }
      .bottom-info a {
        text-decoration: none;
        color: inherit;
      }
      .form-control-flat {
        padding: 3px !important;
      }
      .dragdrop-flat {
        padding: 7px !important;
      }
      .upload-info-flat {
        display: flex;
        white-space: nowrap;
        align-items: center;
      }
      .upload-info-flat i {
        margin: 0 8px;
      }
    `
  ]
})
export class InputFileComponent implements OnInit, OnDestroy {
  public uploader: FileUploader;
  public error: string;
  public filename: string;
  public hasBaseDropZoneOver = false;
  

  // TODO implement
  @Input('eye') public eye: boolean;
  @Input('downloadTemplate') public downloadTemplate: boolean;

  @Input('label') public label: string;

  @Input('accept') public accept: string;

  @Input('parseFn') public parseFn: Function;

  @Input('info') public info: string; 
  @Input('bottomInfo') public bottomInfo: string; 
  @Input('bottomLink') public bottomLink: ILink; 
  @Input('flat') public flat = false; 

  @Input('value') public value: any;
  @Output() public valueChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.uploader = new FileUploader({
      isHTML5: true
    });
    this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
      this.filename = fileItem.file.name;
      if (this.uploader.queue.length > 1) {
        this.uploader.removeFromQueue(this.uploader.queue[0]);
      }
      this.onAddFile(fileItem);
    };
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  ngOnInit() {}

  ngOnDestroy(): void {}

  onAddFile(fileItem: FileItem) {
    const val = this.parseFn
      ? this.parseFn(fileItem.file.rawFile, (err, data) => {
          if (err) {
            console.error('Error: ', err);
          } else {
            this.valueChange.emit(data);
          }
        })
      : fileItem.file.rawFile;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/input-file.component.ts